import Vue from 'vue';

export default {
  getStockList() {
    return Vue.axios.get('/api/v1.0/chanquan/userCenter/queryStockList');
  }
};
